import lessonActions, { reducer as lessonReducer } from './actions';
import * as lessonSelectors from './selectors';

export const reducer = lessonReducer;
export const actions = lessonActions;
export const selectors = lessonSelectors;

export { deleteCLessonReducer } from './actions';
